/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Edge_CachingInputs */

const en_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edge caching`)
};

const ar_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تخزين الحافة`)
};

const bn_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এজ ক্যাশিং`)
};

const de_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edge-Caching`)
};

const es_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento en caché perimetral`)
};

const fr_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en cache périphérique`)
};

const pt_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cache de borda`)
};

const zh_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`边缘缓存`)
};

const tr_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenar önbelleğe alma`)
};

const ru_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пограничное кэширование`)
};

const pl_svchip_edge_caching = /** @type {(inputs: Svchip_Edge_CachingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buforowanie brzegowe`)
};

/**
* | output |
* | --- |
* | "Edge caching" |
*
* @param {Svchip_Edge_CachingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_edge_caching = /** @type {((inputs?: Svchip_Edge_CachingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Edge_CachingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_edge_caching(inputs)
	if (locale === "bn") return bn_svchip_edge_caching(inputs)
	if (locale === "de") return de_svchip_edge_caching(inputs)
	if (locale === "es") return es_svchip_edge_caching(inputs)
	if (locale === "fr") return fr_svchip_edge_caching(inputs)
	if (locale === "pt") return pt_svchip_edge_caching(inputs)
	if (locale === "zh") return zh_svchip_edge_caching(inputs)
	if (locale === "tr") return tr_svchip_edge_caching(inputs)
	if (locale === "ru") return ru_svchip_edge_caching(inputs)
	if (locale === "pl") return pl_svchip_edge_caching(inputs)
	return en_svchip_edge_caching(inputs)
});